import { useEffect, useState } from "react";
import { clientCMSvelas } from "../../sanity/clientCMSvelas.js";
import LoadingContainer from "../LoadingContainer/index.js";
import ErrorContainer from "../ErrorContainer/index.js";
import NoDataContainer from "../NoDataContainer/index.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Candle1 from "../../assets/video/candle-light.webm";
import Candle2 from "../../assets/video/candle-light-2.webm";
import { TbCandle } from "react-icons/tb";
import "./AllCandles.css";

export default function AllCandles(props) {
  const [allCandlesData, setAllCandlesData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  const sevenDaysAgoISO = sevenDaysAgo.toISOString();

  function dateFormat(date) {
    const data = new Date(date);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return (
      <span style={{ color: props.textColor }} className="candle-label">
        {data.toLocaleString("pt-BR", options)}
      </span>
    );
  }

  useEffect(() => {
    setDataContainer(LoadingContainer);
    clientCMSvelas
      .fetch(
        `*[_type == "candle" && _createdAt >= "${sevenDaysAgoISO}"] | order(publishedAt desc) {
        forPerson,
        byPerson,
        "message": message->description,
        publishedAt
    }`,
      )
      .then((data) => {
        setAllCandlesData(data);
        if (data.length === 0)
          setDataContainer(
            <NoDataContainer
              icon={<TbCandle className="no-data-container-icon" />}
              message="Sem velas acesas no momento"
            />,
          );
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!allCandlesData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, []);

  return (
    <Container>
      <Row>
        {allCandlesData && allCandlesData.length > 0
          ? allCandlesData &&
            allCandlesData.map((candle, index) => (
              <Col key={index} className="candle-col">
                <div
                  style={{ backgroundColor: props.white }}
                  className="candle-card"
                >
                  <video
                    autoPlay
                    loop
                    muted
                    preload="metadata"
                    className="candle-card-img"
                    playsInline
                  >
                    <source
                      src={index % 2 === 0 ? Candle1 : Candle2}
                      type="video/webm"
                    />
                  </video>
                  <div className="candle-card-content">
                    <div>
                      <span
                        style={{ color: props.textColor }}
                        className="candle-label"
                      >
                        Em memória de
                      </span>
                      <h4
                        style={{ color: props.titleColor }}
                        className="candle-title"
                      >
                        {candle.forPerson.toUpperCase()}
                      </h4>
                      <span
                        style={{ color: props.textColor }}
                        className="candle-label"
                      >
                        Mensagem de
                      </span>
                      <h4
                        style={{ color: props.textColor }}
                        className="candle-subtitle"
                      >
                        {candle.byPerson}
                      </h4>
                    </div>
                    <p
                      style={{ color: props.textColor }}
                      className="candle-message"
                    >
                      " {candle.message}"
                    </p>
                    {dateFormat(candle.publishedAt)}
                  </div>
                </div>
              </Col>
            ))
          : dataContainer}
      </Row>
    </Container>
  );
}
